import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import Tooltip from 'flarum/common/components/Tooltip';
import classList from 'flarum/common/utils/classList';
import TranslationLabel from './TranslationLabel';
import toggleOriginal, { showingOriginal } from '../utils/toggleOriginal';
export default class TranslationIndicator extends Component {
  view() {
    const {
      model,
      toggle = true,
      className
    } = this.attrs;
    const classes = classList('TranslationIndicator', className, {
      'TranslationIndicator--original': showingOriginal(model)
    });
    if (!toggle) {
      return m("span", {
        className: classes
      }, m(Icon, {
        name: "fas fa-wand-magic-sparkles",
        className: "TranslationIndicator-icon"
      }), m(TranslationLabel, {
        sourceLanguage: model.sourceLanguage?.()
      }));
    }
    if (showingOriginal(model)) {
      return m(Button, {
        className: classList('Button Button--link', classes),
        icon: "fas fa-wand-magic-sparkles",
        onclick: () => toggleOriginal(model),
        loading: !!model.loadingOriginal,
        "aria-pressed": "true"
      }, app.translator.trans('glowingblue-translate.lib.translation.action.show_translation'));
    }
    return m(Tooltip, {
      text: app.translator.trans('glowingblue-translate.lib.translation.action.show_original')
    }, m(Button, {
      className: classList('Button Button--link', classes),
      icon: "fas fa-wand-magic-sparkles",
      onclick: () => toggleOriginal(model),
      loading: !!model.loadingOriginal,
      "aria-pressed": "false"
    }, m(TranslationLabel, {
      sourceLanguage: model.sourceLanguage?.()
    })));
  }
}
flarum.reg.add('glowingblue-translate', 'common/components/TranslationIndicator', TranslationIndicator);